import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom/client";
import "./components/AuthProvider/awsExport"; // Initialize Amplify configuration
import App from "./components/App";
import {
  registerAxiosInterceptor,
  registerFetchInterceptor,
  registerAxiosRequestInterceptor
} from "./utils/interceptors.js";

import "./styles/base.scss";

import registerServiceWorker from "./registerServiceWorker";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

registerAxiosInterceptor();
registerFetchInterceptor();
registerAxiosRequestInterceptor();
registerServiceWorker();
